/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";
import { baseUrl, debug, fetchImageStatus } from "../utils/AppUtil";
import { Link } from "react-router-dom";

import deceasedPlaceholder from './images/avatar-placeholder.svg';


type DeceasedPersonProps = {
    deceasedId: string,
    firstName: string,
    lastName: string,
    yahrzeitDateDisplay: string,
    yahrzeitDesc: string
}

export const DeceasedPerson: React.FC<DeceasedPersonProps> = (props) => {

    const [imageToServe, setImageToServe] = useState(deceasedPlaceholder);
    const [imageAvailable, setImageAvailable] = useState(false);

    useEffect( () => {

        const profileImagePath: string = `image/deceased/${props.deceasedId}/profile`;

        fetchImageStatus(profileImagePath)
        .then( (response: any) => {
            if (response.status === 200) {
                setImageAvailable(true);
                setImageToServe(`${baseUrl}/${profileImagePath}`);
            }
        })
        .catch( (error) => {
            console.log(error);
        });
        
    }, []);

    return (
        <div className="d-flex deceased-person-wrapper">
            <div className="image-profile-wrapper">
                { imageAvailable && <img src={imageToServe} className="image-profile me-4"/> }

                { !imageAvailable && 
                    <>
                        <button className="btn-add-picture jc-txt-body" data-bs-toggle="modal" data-bs-target="#modalSubmitPicture" style={{position: "absolute", marginTop: "-10px", marginLeft: "90px"}}>Add Picture</button>
                        <img src={imageToServe} className="me-4" height="136px" />
                    </>
                }
            </div>

            <div className="d-flex flex-column justify-content-center gap-2">
                <div className="d-flex flex-column gap-1 jc-txt-body">
                    <p className="jc-txt-dark fs-4">{props.firstName} {props.lastName}</p>
                    <p className="jc-txt-dark fs-6">Yahrzeit: <span className="fw-bold">{props.yahrzeitDesc ? props.yahrzeitDesc : "Unavailable"} {props.yahrzeitDateDisplay && "(" +  props.yahrzeitDateDisplay + ")"}</span></p>
                </div>
                
                <div className="deceased-links d-flex gap-2 jc-txt-body">
                    <button type="button" className="deceased-person-button btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#modalYahrzeitReminder" style={{whiteSpace: "nowrap"}}>Yahrzeit Reminder</button>
                    <button type="button" className="deceased-person-button btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#modalStone" style={{whiteSpace: "nowrap"}}>Place a Stone</button>
                    <Link to={'/tree-of-life/' + props.deceasedId} className="deceased-person-button btn btn-outline-dark" style={{whiteSpace: "nowrap", color: "#4d1800 !important"}}>Buy a Leaf</Link>
                    <button type="button" className="deceased-person-button btn btn-outline-dark" data-bs-toggle="modal" data-bs-target="#modalMessage" style={{whiteSpace: "nowrap"}}>Write a Message</button>
                </div>
            </div>
        </div>
    );
}